import API from './axios.js';

export const getLabelByCourtRef = (courtref) =>API.get(`label/label-by-court-ref?courtRef=${courtref}`);